import { IonItem, IonLabel, IonNote } from '@ionic/react';
import { fiatFormat } from 'utils/Currency';
import { roundNumber } from 'utils/Utils';
import './WithdrawalItem.css';

const WithdrawalItem = ({
  withdrawal,
  noLine
}: {
  withdrawal: any;
  noLine?: boolean;
}) => {
  return (
    <IonItem
      className={'withdrawal-item-root withdrawal-item'}
      lines={'none'}>
      <IonLabel className={"ion-text-wrap"}>
        <h2>
          {withdrawal.pay_req
            ? 'Lightning Withdrawal'
            : 'On-Chain Withdrawal'}
        </h2>
        <p>
          {new Date(withdrawal.timestamp).toDateString()}
        </p>
      </IonLabel>
      <IonNote slot="end">
        <IonLabel className={"ion-text-wrap ion-text-right"}>
          <h2>
            {fiatFormat(roundNumber(withdrawal.fiat_amount))}
          </h2>
          <p >{withdrawal.amount} sats</p>
        </IonLabel>
      </IonNote>
    </IonItem>
  );
};

export default WithdrawalItem;
